import { render, staticRenderFns } from "./SMSSignin.vue?vue&type=template&id=46465aea&scoped=true"
import script from "./SMSSignin.vue?vue&type=script&lang=js"
export * from "./SMSSignin.vue?vue&type=script&lang=js"
import style0 from "./SMSSignin.vue?vue&type=style&index=0&id=46465aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46465aea",
  null
  
)

export default component.exports